import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { StockTransfer, StockTransferCreate, StockTransferFilter } from '../data/stockTransfer';

export function createStockTransferService(client: AxiosInstance) {
  return createCrudService<StockTransfer, StockTransferCreate, StockTransferFilter>(client, "/purchase/StockTransfer", "stockTransferId");
}

export type StockTransferService = CrudService<
  StockTransfer,
  StockTransferCreate,
  StockTransferFilter
>;
